export default __webpack_public_path__ + "static/media/di2.16925dbe.jpg";